import Upgrade from './container';

export default Upgrade;



// WEBPACK FOOTER //
// ./src/routes/Upgrade/index.js